import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { Main } from './pages/main';
import { PageNotFound } from './pages/404';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/:invite_code" element={<Main />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
